import { render, staticRenderFns } from "./AxiosInterceptors.vue?vue&type=template&id=5ac4399f&scoped=true"
import script from "./AxiosInterceptors.vue?vue&type=script&lang=js"
export * from "./AxiosInterceptors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4399f",
  null
  
)

export default component.exports